import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { BoxInfo } from 'shared/index'

import SspContext from 'selfServicePortal/contexts/SspContext'
import {
	IMenuDropdownItem,
	menuItems,
} from 'selfServicePortal/constants/menuItems'
import { AuthContext } from '../SDDAuthentication'

export const AuthError = () => {
	const { t } = useTranslation()
	const { setAuthSelect, setErr, setOtpCode } = useContext(AuthContext)
	const { changeComponent } = useContext(SspContext)

	const goBack = (item: IMenuDropdownItem) => {
		changeComponent(item)
	}

	const tryAgain = () => {
		setOtpCode('')
		setAuthSelect(true)
		setErr(false)
	}

	return (
		<div className="sdd-authentication-error">
			<BoxInfo css={'fail'} message={t('SDDAuthError')} />
			<button
				type="button"
				className="btn btn-primary"
				onClick={tryAgain}>
				{t('TryAgain')}
			</button>
			<div className="back-section">
				<button
					type="button"
					className="btn btn-outline dark-gray back-btn"
					onClick={() => goBack(menuItems[0].items[0])}>
					{t('BackToStart')}
				</button>
			</div>
		</div>
	)
}
